import React from "react";
import VideoPlayer from "./VideoPlayer";
import '../styles/Home.css';

const useCases = [
    {
        number: '01',
        title: 'Any type of business',
        description: 'Build a basic but professional landing page for free — no coding, no complexity.',
        video: 'https://youtube.com/shorts/4-iFaqlEdoI',
    },
    {
        number: '02',
        title: 'Restaurants & low-inventory businesses',
        description: 'Create a stunning digital menu or product catalogue your customers can browse instantly.',
        video: 'https://youtube.com/shorts/WncPxw3cHwE',
    },
    {
        number: '03',
        title: 'Stores & high-inventory businesses',
        description: 'Showcase your offers and new arrivals in an eye-catching, shareable format.',
        video: 'https://youtube.com/shorts/zmSnPtOptjQ',
    },
    {
        number: '04',
        title: 'Service providers',
        description: 'Build a polished portfolio that highlights your best work and impresses new clients.',
        video: 'https://youtube.com/shorts/Qjkx3R5XhXQ',
    },
];

const HowTo = () => {
    return (
        <section className="howto-section">
            <div className="howto-header">
                <span className="section-eyebrow">Use cases</span>
                <h2 className="howto-title">
                    <span className="brand-text">Built for every</span> business
                </h2>
                <p className="howto-subtitle">
                    Whatever your business, Menu & Catalog Maker has a solution.
                </p>
            </div>

            <div className="use-cases-grid">
                {useCases.map((uc) => (
                    <div key={uc.number} className="use-case-card fade-in-up">
                        <div className="use-case-body">
                            <span className="use-case-number">{uc.number}</span>
                            <h3 className="use-case-title">{uc.title}</h3>
                            <p className="use-case-description">{uc.description}</p>
                        </div>
                        <div className="use-case-video">
                            <VideoPlayer video={uc.video} />
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default HowTo;
